import React from 'react'

type TextAreaProps = React.InputHTMLAttributes<HTMLTextAreaElement>

export default function TextArea(props: TextAreaProps) {
  return (
    <textarea
      {...props}
      className="border-b my-1 border-b-gray-400 focus:border-b-gray-100 outline-none text-white bg-transparent p-2 w-full"
    />
  )
}
